import Footer from "../components/footer";
import Header from "../components/header";
import React from "react";

const PrivacyPolicy = () => {
  <Header />;
  return (
    <div>
      <Header />
      <div class="my-8 max-w-5xl mx-auto">
        <h2 class="text-lg font-medium">Effective Date: Dec 1, 2024</h2>
        <p class="text-lg font-medium mt-2">
          Welcome to AI Writer Pro! Your privacy is important to us, and we are
          committed to protecting the personal information you share while using
          our application.
        </p>
        <p class="text-base mt-2">
          This Privacy Policy outlines how we collect, use, and protect your
          data. By using AI Writer Pro, you agree to the practices described in
          this policy.
        </p>

        <h3 class="text-base font-semibold mt-4">Information We Collect</h3>
        <p class="text-base mt-2">
          We collect certain types of information to enhance your experience
          with AI Writer Pro.
        </p>
        <p class="text-base mt-2">&bull; Personal Information:</p>
        <div class="ml-3">
          <p class="text-base mt-2">
            &bull; Sign up for an account (e.g., name, email address).
          </p>
          <p class="text-base mt-2">
            &bull; Subscribe to premium services (e.g., billing information via
            Apple).
          </p>
          <p class="text-base mt-2">&bull; Contact customer support.</p>
        </div>
        <p class="text-base mt-2">&bull; Non-Personal Information:</p>
        <div class="ml-3">
          <p class="text-base mt-2">
            &bull; Device information (e.g., operating system, device type).
          </p>
          <p class="text-base mt-2">
            &bull; Usage data (e.g., features accessed, time spent in the app).
          </p>
        </div>

        <h3 class="text-md font-semibold mt-4">Subscriptions</h3>
        <p class="text-base mt-2">
          AI Writer Pro offers auto-renewing subscriptions. By purchasing a
          subscription, you agree to the terms below:
        </p>
        <div class="ml-3">
          <p class="text-base mt-2">
            <span class="font-bold">• Discount on First Order:</span> All
            subscriptions are discounted by 40% for the first order only.
          </p>
          <p class="text-base mt-2">
            <span class="font-bold">• Subscription Options:</span>
          </p>
          <div class="ml-3">
            <p class="text-base mt-2">
              • Weekly Subscription: Original Price: $3.99, First Order Price:
              $2.39, Length: 7 Days, Auto-renews every 7 days at the full price
              of $3.99.
            </p>
            <p class="text-base mt-2">
              • Monthly Subscription: Original Price: $12.99, First Order Price:
              $7.79, Length: 30 Days, Auto-renews every 30 days at the full
              price of $12.99.
            </p>
            <p class="text-base mt-2">
              • Yearly Subscription: Original Price: $109.99, First Order Price:
              $65.99, Length: 365 Days, Auto-renews annually at the full price
              of $109.99.
            </p>
          </div>
          <p class="text-base mt-2">
            <span class="font-bold">• Auto-Renewal Policy:</span> Subscriptions
            automatically renew unless canceled at least 24 hours before the end
            of the current period.
          </p>
          <p class="text-base mt-2">
            • Your iTunes account will be charged for renewal within 24 hours
            prior to the end of the current period.
          </p>
          <p class="text-base mt-2">
            • Manage subscriptions and turn off auto-renewal in Settings &gt;
            Apple ID &gt; Subscriptions on your iOS device.
          </p>
        </div>

        <h3 class="text-base font-semibold mt-4">Permissions Required</h3>
        <p class="text-base mt-2">
          To provide specific functionalities, we may request:
        </p>
        <div class="ml-3">
          <p class="text-base mt-2">
            &bull; Camera Access: For capturing images used in the image-to-text
            feature.
          </p>
          <p class="text-base mt-2">
            &bull; Microphone Access: For speech-to-text functionality.
          </p>
          <p class="text-base mt-2">
            &bull; Photo Library Access: To process selected images for text
            extraction.
          </p>
        </div>
        <p class="text-base mt-2">
          We do not access or use these permissions without your explicit
          consent.
        </p>

        <h3 class="text-base font-semibold mt-4">
          How We Use Your Information
        </h3>
        <p class="text-base mt-2">
          We use the collected information for the following purposes:
        </p>
        <div class="ml-3">
          <p class="text-base mt-2">
            &bull; To provide and improve app functionalities.
          </p>
          <p class="text-base mt-2">
            &bull; To process subscription payments via Apple.
          </p>
          <p class="text-base mt-2">
            &bull; To analyze usage patterns for app optimization.
          </p>
          <p class="text-base mt-2">
            &bull; To provide customer support and respond to inquiries.
          </p>
        </div>

        <h3 class="text-base font-semibold mt-4">Data Sharing</h3>
        <p class="text-base mt-2">
          Your data is never sold to third parties. We only share information
          under the following conditions:
        </p>
        <div class="ml-3">
          <p class="text-base mt-2">
            &bull; With Service Providers: To process payments or provide app
            functionality (e.g., Apple’s payment system).
          </p>
          <p class="text-base mt-2">
            &bull; Legal Compliance: If required by law or to protect our legal
            rights.
          </p>
          <p class="text-base mt-2">
            &bull; With Consent: When you explicitly agree to share data.
          </p>
        </div>

        <h3 class="text-base font-semibold mt-4">Your Rights</h3>
        <p class="text-base mt-2">
          As an AI Writer Pro user, you have the following rights:
        </p>
        <div class="ml-3">
          <p class="text-base mt-2">
            &bull; Access: Request access to your personal data.
          </p>
          <p class="text-base mt-2">
            &bull; Correction: Correct inaccurate or incomplete data.
          </p>
          <p class="text-base mt-2">
            &bull; Deletion: Request deletion of your data (subject to legal
            obligations).
          </p>
          <p class="text-base mt-2">
            &bull; Opt-Out: Manage permissions or unsubscribe from marketing
            communications.
          </p>
        </div>

        <h3 class="text-base font-semibold mt-4">Children’s Privacy</h3>
        <p class="text-base mt-2">
          AI Writer Pro is not intended for users under the age of 13. We do not
          knowingly collect personal data from children. If we become aware that
          a child has provided us with personal information, we will take steps
          to delete such data.
        </p>

        <h3 class="text-base font-semibold mt-4">Third-Party Links</h3>
        <p class="text-base mt-2">
          AI Writer Pro may contain links to third-party websites or services.
          We are not responsible for their privacy practices or content.
        </p>

        <h3 class="text-base font-semibold mt-4">Changes to This Policy</h3>
        <p class="text-base mt-2">
          We may update this Privacy Policy periodically. Any changes will be
          posted here, and the updated policy will include a new “Effective
          Date.”
        </p>

        <h3 class="text-base font-semibold mt-4">Contact Us</h3>
        <p class="text-base mt-2">
          If you have any questions or concerns about this Privacy Policy,
          please contact us at:
        </p>
        <p class="text-base ml-3 mt-1">Email: info@thekaizenglobal.com</p>
        <p class="text-base ml-3 mt-1">
          Address: 3rd Floor AL Nawaz Arcade Next to Rawalpindi Urology
          Hospital, Murree Road Rawalpindi, Punjab
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
